import React from 'react';
import { MenuItem } from '@bingads-webui-react/primitive';
import { generateRecentReportMenuItems } from './generate-recent-report-menu-items';
import { generateDefaultReportMenuItem } from './generate-default-report-menu-item';
import { generateSavedReportMenuItem } from './generate-saved-report-menu-item';
import { generateCustomReportBuilderMenuItem } from './generate-custom-report-builder-menu-item';

export function genereateMenuProps({
  siteMap, classes, i18n, navigate, serverContext, permissions,
  recentReports, savedReports,
  onClickRecentReportItem,
  onClickDefaultReportItem,
  onClickSavedReportItem,
  onClickCustomReportBuilderItem,
}) {
  const allReportsTitle = i18n.getString(_TL_('All reports'));
  const menuItems = [
    ...generateRecentReportMenuItems({
      recentReports, siteMap, classes, navigate, serverContext, onClickRecentReportItem,
    }),
    {
      key: 'all-reports',
      onRender: () => (<MenuItem header>{allReportsTitle}</MenuItem>),
    },
    generateDefaultReportMenuItem({
      siteMap, i18n, classes, navigate, onClickDefaultReportItem, allReportsTitle,
    }),
    generateSavedReportMenuItem({
      savedReports, i18n, classes, navigate, onClickSavedReportItem, allReportsTitle,
    }),
    ...(permissions && permissions.dynamic && permissions.dynamic.CustomReportBuilder ?
      [generateCustomReportBuilderMenuItem({siteMap, i18n, navigate, onClickCustomReportBuilderItem})] : []
    )
  ];

  return {
    items: menuItems,
  };
}
